<template>
  <div v-if="display" class="show hide-md">
    <div class="text-center">
      <div v-if="!!categoryLink" class="menu-item subheading-1">
        <div
          class="flex justify-center items-center"
          @mouseover="$store.dispatch('navigation/setDropdownType', 'category')"
        >
          {{ categoryLink.name }}
          <span class="vertical-line" />
        </div>
      </div>
      <template v-if="!!featuredLinks">
        <div
          class="inline-flex"
          @mouseover="dropdown === 'category' && $store.dispatch('navigation/setDropdownType', 'closed')"
        >
          <div v-for="link in featuredLinks.view_components" :key="link.id" class="menu-item">
            <router-link
              v-if="$utils.getPathFromUrl(link.info.url).startsWith('/')"
              :to="$utils.getPathFromUrl(link.info.url)"
              class="menu-item-link subheading-1"
              @click.native="$store.dispatch('navigation/setDropdownType', 'closed')"
            >
              {{ link.info.link_title }}
            </router-link>
            <a v-else :key="link.id" :href="link.info.url" class="menu-item subheading-1 default-hover" target="_self">
              {{ link.info.link_title }}
            </a>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { NavigationApi } from '@/api'
import session from '@/services/session'

export default {
  name: 'RetailerNavigationBar',
  props: {
    display: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      categoryLink: null,
      featuredLinks: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'userState',
      dropdown: 'navigation/dropdownState'
    })
  },
  async mounted() {
    this.$logger.logAction('RetailerNavigationBar mounted')
    await this.getNavitationLinks()
  },
  methods: {
    getNavitationLinks
  }
}

async function getNavitationLinks() {
  try {
    const userInfo = session.getUserInfo()
    const userRole = session.getRole()

    const [links] = await NavigationApi.getNavigationV2({ role: userRole, userId: userInfo ? userInfo.id : null })
    this.categoryLink = links.children_containers.find((item) => item.container_type === 'NAVIGATION_V2')
    this.featuredLinks = links.children_containers.find((item) => item.container_type === 'FEATURED_LINKS_RETAILER')
    const categories = this.categoryLink.children_containers.find(
      (item) => item.container_type === 'NAVIGATION_V2_CATEGORIES'
    )
    const collections = this.categoryLink.children_containers.find(
      (item) => item.container_type === 'NAVIGATION_V2_COLLECTION'
    )
    this.$store.dispatch('navigation/setCategories', categories)
    this.$store.dispatch('navigation/setCollections', collections)
  } catch (error) {
    this.$handleError(this, error)
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/base/_vars.scss';
@import '@/assets/sass/base/_mixins.scss';

.menu-item {
  padding: 0 8px 10px;
  display: inline-block;
  border-bottom: 1px solid transparent;
  white-space: nowrap;
  text-overflow: ellipsis;
  @include transition(border-color, 150ms, ease-in-out);

  a {
    &.router-link-active {
      background: linear-gradient(0deg, $color-green 40%, transparent 50%);
    }

    &:hover {
      cursor: pointer;
      color: $color-grey-4;
    }
  }

  &.default-hover {
    &:hover {
      cursor: pointer;
      color: $color-grey-4;
    }
  }

  &:not(.router-link) {
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }

  &.active {
    cursor: pointer;
    border-color: $color-black !important;
  }
}

.vertical-line {
  height: 24px;
  width: 1px;
  background-color: $color-grey-3;
}
</style>
